import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { DefaultServices } from '../../../constants/DefaultServices';
import FilterSelector from '../../elements/FilterSelector';
import {
    getHeadlineContentFromQuery,
    DEFAULT_HEADLINE_CONTENT,
} from '../../../content/HeadlineContent';

const ContentSection = props => {
    const [searchParams] = useSearchParams();

    const getHeadlineContent = () => {
        let content = DEFAULT_HEADLINE_CONTENT;
        let adviserType = searchParams.get('vf_adviser_type');
        let consumerLocation = searchParams.get('vf_consumer_location');

        if (adviserType || consumerLocation) {
            content = getHeadlineContentFromQuery(adviserType, consumerLocation);
        }

        return content;
    };

    const renderBanner = () => {
        const content = getHeadlineContent();

        return (
            <div className="banner-info">
                <h1 className="hero-banner__header hidden-mobile">
                    <span className="line">{content.headline.firstLine}&nbsp;</span>
                    <span className="line">{content.headline.secondLine}</span>
                </h1>
                <h1 className="hero-banner__header mobile-only">
                    <span className="line">{content.headline.mobile.firstLine}&nbsp;</span>
                    <span className="line">{content.headline.mobile.secondLine}</span>
                </h1>
                <div className="hero-banner__subtitle">
                    With more than <span className="semi-bold">5,000</span> Financial Advisers and
                    over <span className="semi-bold">60,000</span> reviews, VouchedFor is home to
                    the UK's top Financial Advisers. Simply tell us a little bit about you, and
                    we'll find the perfect adviser to help with your finances.
                </div>
            </div>
        );
    };

    const renderForm = () => {
        return (
            <div className="hero-banner__down matching">
                <div id="form-anchor"></div>
                <div className="banner-form">
                    <div className="banner-form__container">
                        <h2>What are you looking for help with?</h2>
                        <FilterSelector filters={DefaultServices} />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="app__landing-page__section--full">
            <div className="app__landing-page__full-image hero-banner__image">
                <div className="opacity-layer">
                    <div className="app__landing-page__hero-banner">
                        <div className="hero-banner__up">{renderBanner()}</div>
                        {renderForm()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentSection;
